// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Metrics {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* make the title sit at the top-left */
    gap: 20px;
    /* reduce top padding and pull the block upward so the title/underline sits closer to the section top */
    padding: 12px 20px 20px;
    margin-top: -90px;
    background-color: transparent;
    /* transparent section background so underlying section color shows through */
    border-radius: 10px;
    flex-wrap: wrap;
    /* Ensure wrapping on smaller screens */
}

.Metrics-row {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 20px;
}

@media (max-width: 900px) {
    .Metrics { margin-top: -8px; padding: 8px 16px 16px; }
}

.Metrics-title {
    font-size: 4rem;
    color: #000;
    z-index: 1;
    margin-bottom: 28px;
    /* size to content so the underline only spans the text */
    display: inline-block;
    width: auto;
    text-align: center;
    padding: 0px 0 20px; /* add bottom padding for a taller header area */
    position: relative; /* for the underline pseudo-element */
    opacity: 0;
    transform: translateX(-28px);
    animation: slideInLeft 700ms cubic-bezier(.2,.9,.2,1) 500ms forwards;
}

/* Underline as a pseudo-element so we can animate the bar independently */
.Metrics-title::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 6px; /* line up with the title's bottom padding */
    height: 2px;
    width: 100%;
    background: rgba(0,0,0,0.12);
    transform-origin: left;
    transform: scaleX(0);
    animation: underlineGrow 700ms cubic-bezier(.2,.9,.2,1) 600ms forwards;
}

.Metric {
    text-align: center;
    /* Make the metric card background transparent so it blends with section */
    background-color: transparent;
    /* Use black text for legibility on light backgrounds */
    color: #000;
    padding: 20px;
    border-radius: 10px;
    min-width: 150px;
    flex: 1 1;
}

.Metric h2 {
    /* Larger, responsive numbers for better emphasis */
    font-size: clamp(2.6rem, 6.5vw, 4rem);
    margin: 0;
    font-weight: 700;
    line-height: 1;
    animation: countUp 2s ease-out forwards;
    /* Keep final state */
    color: #000; /* black values */
}

.Metric p {
    font-size: 1.2rem;
    margin: 5px 0 0;
    color: #000; /* black labels */
}

@keyframes countUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Slide the header left -> right and fade in */
@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-28px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

/* Grow the underline from left to right */
@keyframes underlineGrow {
    from { transform: scaleX(0); opacity: 0; }
    to   { transform: scaleX(1); opacity: 1; }
}

/* Respect users who prefer reduced motion */
@media (prefers-reduced-motion: reduce) {
    .Metrics-title,
    .Metrics-title::after,
    .Metric h2 {
        animation: none !important;
        transition: none !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Metrics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,uCAAuC;IAChE,SAAS;IACT,uGAAuG;IACvG,uBAAuB;IACvB,iBAAiB;IACjB,6BAA6B;IAC7B,6EAA6E;IAC7E,mBAAmB;IACnB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW,gBAAgB,EAAE,sBAAsB,EAAE;AACzD;;AAEA;IACI,eAAe;IACf,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,yDAAyD;IACzD,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,mBAAmB,EAAE,gDAAgD;IACrE,kBAAkB,EAAE,qCAAqC;IACzD,UAAU;IACV,4BAA4B;IAC5B,oEAAoE;AACxE;;AAEA,0EAA0E;AAC1E;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW,EAAE,4CAA4C;IACzD,WAAW;IACX,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,oBAAoB;IACpB,sEAAsE;AAC1E;;AAEA;IACI,kBAAkB;IAClB,0EAA0E;IAC1E,6BAA6B;IAC7B,uDAAuD;IACvD,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,mDAAmD;IACnD,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,qBAAqB;IACrB,WAAW,EAAE,iBAAiB;AAClC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW,EAAE,iBAAiB;AAClC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,+CAA+C;AAC/C;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,0CAA0C;AAC1C;IACI,OAAO,oBAAoB,EAAE,UAAU,EAAE;IACzC,OAAO,oBAAoB,EAAE,UAAU,EAAE;AAC7C;;AAEA,4CAA4C;AAC5C;IACI;;;QAGI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ","sourcesContent":[".Metrics {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* make the title sit at the top-left */\n    gap: 20px;\n    /* reduce top padding and pull the block upward so the title/underline sits closer to the section top */\n    padding: 12px 20px 20px;\n    margin-top: -90px;\n    background-color: transparent;\n    /* transparent section background so underlying section color shows through */\n    border-radius: 10px;\n    flex-wrap: wrap;\n    /* Ensure wrapping on smaller screens */\n}\n\n.Metrics-row {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    gap: 20px;\n}\n\n@media (max-width: 900px) {\n    .Metrics { margin-top: -8px; padding: 8px 16px 16px; }\n}\n\n.Metrics-title {\n    font-size: 4rem;\n    color: #000;\n    z-index: 1;\n    margin-bottom: 28px;\n    /* size to content so the underline only spans the text */\n    display: inline-block;\n    width: auto;\n    text-align: center;\n    padding: 0px 0 20px; /* add bottom padding for a taller header area */\n    position: relative; /* for the underline pseudo-element */\n    opacity: 0;\n    transform: translateX(-28px);\n    animation: slideInLeft 700ms cubic-bezier(.2,.9,.2,1) 500ms forwards;\n}\n\n/* Underline as a pseudo-element so we can animate the bar independently */\n.Metrics-title::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 6px; /* line up with the title's bottom padding */\n    height: 2px;\n    width: 100%;\n    background: rgba(0,0,0,0.12);\n    transform-origin: left;\n    transform: scaleX(0);\n    animation: underlineGrow 700ms cubic-bezier(.2,.9,.2,1) 600ms forwards;\n}\n\n.Metric {\n    text-align: center;\n    /* Make the metric card background transparent so it blends with section */\n    background-color: transparent;\n    /* Use black text for legibility on light backgrounds */\n    color: #000;\n    padding: 20px;\n    border-radius: 10px;\n    min-width: 150px;\n    flex: 1;\n}\n\n.Metric h2 {\n    /* Larger, responsive numbers for better emphasis */\n    font-size: clamp(2.6rem, 6.5vw, 4rem);\n    margin: 0;\n    font-weight: 700;\n    line-height: 1;\n    animation: countUp 2s ease-out forwards;\n    /* Keep final state */\n    color: #000; /* black values */\n}\n\n.Metric p {\n    font-size: 1.2rem;\n    margin: 5px 0 0;\n    color: #000; /* black labels */\n}\n\n@keyframes countUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Slide the header left -> right and fade in */\n@keyframes slideInLeft {\n    from {\n        opacity: 0;\n        transform: translateX(-28px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n/* Grow the underline from left to right */\n@keyframes underlineGrow {\n    from { transform: scaleX(0); opacity: 0; }\n    to   { transform: scaleX(1); opacity: 1; }\n}\n\n/* Respect users who prefer reduced motion */\n@media (prefers-reduced-motion: reduce) {\n    .Metrics-title,\n    .Metrics-title::after,\n    .Metric h2 {\n        animation: none !important;\n        transition: none !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
